// What an anonymous reader read here, kept in this browser only
// (OF.Layouts.Site.Reads, behind :signup_prompts): the stories whose pages
// they opened, for the count on the card at the end of a story, and the
// articles they opened from them, which a new account takes into its
// reading history (OF.Readers.Import). Nothing here is sent anywhere until
// the reader signs in; then the list goes, once, and is forgotten.

const KEY = "of:reads";
const DAYS = 30;
const MAX = 50;
const DAY_MS = 24 * 60 * 60 * 1000;

// Entries are [id, when]; anything else, or older than DAYS, is dropped.
function recent(value) {
  const since = Date.now() - DAYS * DAY_MS;
  if (!Array.isArray(value)) return [];

  return value.filter(
    (entry) => Array.isArray(entry) && typeof entry[0] === "string" && entry[1] >= since,
  );
}

function load() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY)) || {};
    return {stories: recent(saved.stories), articles: recent(saved.articles)};
  } catch (_error) {
    // No storage (a locked-down browser) or a value someone else wrote.
    return {stories: [], articles: []};
  }
}

function save(reads) {
  try {
    localStorage.setItem(KEY, JSON.stringify(reads));
  } catch (_error) {
    // Full or refused: the reads are simply not kept.
  }
}

// Newest first, each id once, at most MAX.
function add(entries, id) {
  return [[id, Date.now()], ...entries.filter(([other]) => other !== id)].slice(0, MAX);
}

// A story page opened: kept, and the story page told how many there are.
export function viewed(storyId) {
  const reads = load();
  reads.stories = add(reads.stories, storyId);
  save(reads);
  globalThis.Hologram.dispatchAction("stories_read", "page", {count: reads.stories.length});
}

// An article opened from a story page.
export function opened(articleId) {
  const reads = load();
  reads.articles = add(reads.articles, articleId);
  save(reads);
}

// A signed-in page: the list is forgotten, and handed to the layout first
// when the account may take it (`keep`).
export function take(keep) {
  const {articles} = load();

  try {
    localStorage.removeItem(KEY);
  } catch (_error) {
    // Nothing kept, nothing to forget.
  }

  if (keep && articles.length > 0) {
    globalThis.Hologram.dispatchAction("import_reads", "layout", {ids: articles.map(([id]) => id)});
  }
}
